import CompanyLogo from "@components/company_logo.tsx";
import { Body } from "@sprout/typography.tsx";
import AlertTags from "@components/alert_tags.tsx";
import { Subscription } from "@/pages/dashboard.tsx";
import { router } from "@inertiajs/react";

interface Props {
  subscription: Subscription;
}

export const JobAlertsRow = ({ subscription }: Props) => {
  const filters = subscription.filters || [];
  const hasFilters = filters.length > 0;

  const handleClick = () => {
    router.visit(subscription.editPath);
  };

  return (
    <div className="job-alerts-widget__row" onClick={handleClick}>
      <div className="job-alerts-widget__row__left">
        <CompanyLogo
          logoUrl={subscription.logoUrl}
          size="xxsmall"
          companyName={subscription.boardName}
        />
        <Body>{subscription.boardName}</Body>
      </div>
      {hasFilters && (
        <div className="job-alerts-widget__row__right">
          <AlertTags values={filters} />
        </div>
      )}
    </div>
  );
};
